import React, { useState, useEffect } from 'react';
import './ProzessanalyseModal.css';

const ProzessanalyseModal = ({ prozess, analyse, onSave, onClose }) => {
    const [formData, setFormData] = useState({
        vertraulichkeit: 'normal',
        integritaet: 'normal',
        verfuegbarkeit: 'normal',
        authentizitaet: 'normal',
        vertraulichkeit_begruendung: '',
        integritaet_begruendung: '',
        verfuegbarkeit_begruendung: '',
        authentizitaet_begruendung: '',
        status: 'entwurf',
    });

    useEffect(() => {
        if (analyse) {
            setFormData({
                vertraulichkeit: analyse.vertraulichkeit || 'normal',
                integritaet: analyse.integritaet || 'normal',
                verfuegbarkeit: analyse.verfuegbarkeit || 'normal',
                authentizitaet: analyse.authentizitaet || 'normal',
                vertraulichkeit_begruendung: analyse.vertraulichkeit_begruendung || '',
                integritaet_begruendung: analyse.integritaet_begruendung || '',
                verfuegbarkeit_begruendung: analyse.verfuegbarkeit_begruendung || '',
                authentizitaet_begruendung: analyse.authentizitaet_begruendung || '',
                status: analyse.status || 'entwurf',
            });
        }
    }, [analyse]);

    const handleSchutzzieleChange = (schutzziel, wert) => {
        setFormData(prev => ({
            ...prev,
            [schutzziel]: wert
        }));
    };

    const handleBegruendungChange = (schutzziel, wert) => {
        setFormData(prev => ({
            ...prev,
            [`${schutzziel}_begruendung`]: wert
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    const schutzstufen = [
        { value: 'gering', label: 'Gering', color: '#10b981' },
        { value: 'normal', label: 'Normal', color: '#22c55e' },
        { value: 'hoch', label: 'Hoch', color: '#f59e0b' },
        { value: 'sehr_hoch', label: 'Sehr Hoch', color: '#ef4444' },
    ];

    const schutzziele = [
        {
            key: 'vertraulichkeit',
            label: 'Vertraulichkeit',
            description: 'Schutz vor unbefugter Kenntnisnahme von Informationen',
        },
        {
            key: 'integritaet',
            label: 'Integrität',
            description: 'Schutz vor unberechtigter Veränderung von Informationen',
        },
        {
            key: 'verfuegbarkeit',
            label: 'Verfügbarkeit',
            description: 'Gewährleistung des Zugriffs auf Informationen bei Bedarf',
        },
        {
            key: 'authentizitaet',
            label: 'Authentizität',
            description: 'Sicherstellung der Echtheit und Glaubwürdigkeit von Informationen',
        },
    ];

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content prozessanalyse-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <div>
                        <h2>Schutzbedarfsanalyse</h2>
                        <p className="modal-subtitle">{prozess.prozess_name}</p>
                    </div>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="info-box">
                            <p>
                                <strong>BSI IT-Grundschutz & DORA:</strong> Bewerten Sie die vier Schutzziele.
                                Der Gesamtschutzbedarf wird automatisch aus dem höchsten Wert berechnet (Maximum-Prinzip).
                            </p>
                        </div>

                        {schutzziele.map((schutzziel) => (
                            <div key={schutzziel.key} className="schutzziel-group">
                                <h3 className="schutzziel-title">{schutzziel.label}</h3>
                                <p className="schutzziel-description">{schutzziel.description}</p>

                                <div className="stufen-buttons">
                                    {schutzstufen.map((stufe) => {
                                        const isSelected = formData[schutzziel.key] === stufe.value;
                                        return (
                                            <button
                                                key={stufe.value}
                                                type="button"
                                                className={`stufe-btn stufe-btn-${stufe.value} ${isSelected ? 'selected' : ''}`}
                                                onClick={() => handleSchutzzieleChange(schutzziel.key, stufe.value)}
                                            >
                                                <span className="stufe-label">{stufe.label}</span>
                                            </button>
                                        );
                                    })}
                                </div>

                                <div className="form-group">
                                    <label htmlFor={`${schutzziel.key}_begruendung`}>
                                        Begründung (optional)
                                    </label>
                                    <textarea
                                        id={`${schutzziel.key}_begruendung`}
                                        value={formData[`${schutzziel.key}_begruendung`]}
                                        onChange={(e) => handleBegruendungChange(schutzziel.key, e.target.value)}
                                        placeholder="Begründen Sie Ihre Bewertung..."
                                        rows="2"
                                    />
                                </div>
                            </div>
                        ))}

                        <div className="form-group">
                            <label htmlFor="status">Status</label>
                            <select
                                id="status"
                                value={formData.status}
                                onChange={(e) => setFormData(prev => ({ ...prev, status: e.target.value }))}
                            >
                                <option value="entwurf">Entwurf</option>
                                <option value="in_bearbeitung">In Bearbeitung</option>
                                <option value="abgeschlossen">Abgeschlossen</option>
                            </select>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" onClick={onClose} className="btn-secondary">
                            Abbrechen
                        </button>
                        <button type="submit" className="btn-primary">
                            {analyse ? 'Aktualisieren' : 'Erstellen'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ProzessanalyseModal;